import { Table } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import "./Document.scss";
import SoftButton from "StyleFeatures/SoftButton";
import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { updateDocumentInfo } from "../Services/Actions/actions";
import API from "api/endpoints";
import Footer from "Common/Footer";
import axiosInstance from "api/axiosInstance";

function Documents({ onNext, onBack, employeeDetail, isEditMode }) {
  const [openModel, setOpenModel] = useState(true);
  const [error, setError] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleuploadOpenModel = () => {
    setOpenModel(false);
  };
  const handleCloseModel = () => {
    setOpenModel(true);
  };
  const { personal, job, emergency, benefits } = useSelector((state) => state);
  // const {
  //    uploadD,
  //  uploadDError,
  // setDocFileError,
  // handleDocumentChange,
  // validateDocumentValidation,
  //  setUploadD,
  //  } = documentsService();
  const dispatch = useDispatch();
  const [docName, setDocName] = useState("");
  const [docfile, setDocFile] = useState(null);

  const [buttonLabel, setButtonLabel] = useState("Save");

  useEffect(() => {
    if (isEditMode) {
      setButtonLabel("Update");
    } else {
      setButtonLabel("Save");
    }
  }, [isEditMode]);

  useEffect(() => {
    fetchData();
  }, []);

  const handleNext = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("docfile", docfile); // Append the uploaded file
    dispatch(updateDocumentInfo(docfile));

    Object.entries(personal).forEach(([key, value]) => {
      formData.append(key, value);
    });
    // Append job properties
    Object.entries(job).forEach(([key, value]) => {
      formData.append(`JobRequestDto.${key}`, value);
    });

    // Append emergency properties
    Object.entries(emergency).forEach(([key, value]) => {
      formData.append(`EmergencyRequestDto.${key}`, value);
    });

    // Append benefits properties
    Object.entries(benefits).forEach(([key, value]) => {
      formData.append(`BenefitsDependentsDto.${key}`, value);
    });

    Object.entries(docfile).forEach(([key, value]) => {
      formData.append(`UploadDocumentRequestDto.${key}`, value);
    });

    try {
      if (isEditMode) {
        await axiosInstance.post(
          API.employee.updatePersonalInfo(employeeDetail.personalId),
          formData
        );
        toast.success("Data has Been Added Successfully", {
          autoClose: 1000,
          style: { background: "lightgreen", color: "white" },
        });
        fetchData();
        setOpenModel(true);
      } else {
        await axiosInstance.post(API.employee.create, formData);
        toast.success("Data has Been Added Successfully", {
          autoClose: 1000,
          style: { background: "lightgreen", color: "white" },
        });
        fetchData();
        setOpenModel(true);
      }
    } catch (error) {
      console.error("Error adding personal information:", error);
      toast.error(error.message || "Failed to add personal information", {
        autoClose: 5000,
        style: { background: "lightcoral", color: "white" },
      });
    }
  };

  async function fetchData() {
    try {
      const response = await axiosInstance.get(API.employee.getAll(null,null));
      const responseData = response.data;
      // Extract data from the response
      const document = responseData.document;
      // Generate rows based on the fetched data
      const updatedRows = document.map((info) => {
        // Function to format the date and time
        function formatDateTime(dateTimeString) {
          const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          const date = new Date(dateTimeString);
          const month = months[date.getMonth()];
          const day = date.getDate();
          const year = date.getFullYear();
          let hours = date.getHours();
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12;
          hours = hours ? hours : 12;
          const minutes = date.getMinutes();
          return `${month} ${day < 10 ? "0" : ""}${day}, ${year} ${hours}:${
            minutes < 10 ? "0" : ""
          }${minutes} ${ampm}`;
        }

        return {
          key: info.personalId.toString(),
          FileName: (
            <span
              style={{ cursor: "pointer" }}
              onClick={() => handlePdfPreview(`${apiUrl}/${info.docfile}`)}
            >
              {info.docfile}
            </span>
          ),
          Date: <span>{formatDateTime(info.uploadedAt)}</span>,
          Action: (
            <span
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <EyeOutlined
                className="eyeOutlined"
                onClick={() => handlePdfPreview(`${apiUrl}/${info.docfile}`)}
              />
            </span>
          ),
        };
      });

      // Update dataSource state
      setDataSource(updatedRows);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const [dataSource, setDataSource] = useState([]);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [pdfPreview, setPdfPreview] = useState(true);

  const handlePdfPreview = (pdfUrl) => {
    setSelectedPdf(pdfUrl);
    setPdfPreview(false);
  };
  const handlePerviewBack = () => {
    setPdfPreview(true);
  };

  const handleUploadDocChange = (e) => {
    const file = e.target.files[0];
    const allowedExtensions = [".pdf", ".PDF", ".docx", ".DOCX", ".doc", ".DOC"];

    if (file) {
      const fileExtension = file.name.split(".").pop();
      if (!allowedExtensions.includes("." + fileExtension)) {
        setError("Unsupported file type. Only PDF and DOCX files are allowed.");
        setDocFile({ docfile: null }); // Update the state with null
        return;
      }
      setError("");
      setDocFile({ docfile: file }); // Update the state with the selected file
    }
  };

  const columns = [
    {
      title: "File Name",
      dataIndex: "FileName",
      key: "FileName",
    },
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
    },
    {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
    },
  ];

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      const success = await handleNext();
      if (success) {
        toast.success("Data has Been Added Successfully", {
          autoClose: 5000,
          style: { background: "lightgreen", color: "white" },
        });
      }
    } catch (error) {
      toast.error(error.message || "Added failed", {
        autoClose: 5000,
        style: { background: "lightcoral", color: "white" },
      });
    }
  };
  const handleDNext = () => {
    onNext();
  };
  const handleBack = () => {
    onBack();
  };

  return (
    <>
      {pdfPreview && (
        <div className="card">
          <div className="card-header" style={{ position: "relative" }}>
            <h5>Documents</h5>
          </div>
          <div className="card-body">
            {openModel && (
              <>
                <div className="row mb-3">
                  <ToastContainer />
                  <div className="col-md-12 mb-3">
                    <SoftButton
                      variant="outlined"
                      color="info"
                      size="small"
                      onClick={handleuploadOpenModel}
                    >
                      Upload Document
                    </SoftButton>
                  </div>
                  <Table
                    className="custom-table"
                    bordered
                    dataSource={dataSource}
                    columns={columns}
                    pagination={{ pageSize: 10 }}
                  />
                </div>
                <div className="col-md-12">
                  <SoftButton
                    variant="outlined"
                    style={{ float: "inline-end" }}
                    color="info"
                    size="small"
                    onClick={handleDNext}
                  >
                    Next
                  </SoftButton>
                  <SoftButton
                    variant="outlined"
                    style={{ float: "inline-end", marginRight: "10px" }}
                    color="black"
                    size="small"
                    onClick={handleBack}
                  >
                    Back
                  </SoftButton>
                </div>
              </>
            )}
            {!openModel && (
              <div className="card-body">
                <form onSubmit={onSubmit} encType="multipart/form-data">
                  <div className="row">
                    {/* <div className="col-md-5">
                      <div className="form-group">
                        <input
                          className="form-control"
                          type="text"
                          onChange={(e) => setDocName(e.target.value)}
                          placeholder="Enter file name here"
                        />
                      </div>
                    </div> */}
                    <div className="col-md-5">
                      <div className="form-group">
                        <input
                          className="form-control"
                          type="file"
                          accept=".pdf,.PDF,.docx,.DOCX,.doc,.DOC"
                          onChange={(e) => {
                            handleUploadDocChange(e);
                          }}
                        />
                        {error && <p style={{ color: "red" }}>{error}</p>}
                      </div>
                    </div>
                    <div className="col-md-12">
                      <SoftButton
                        variant="outlined"
                        style={{ float: "inline-end" }}
                        color="info"
                        size="small"
                        type="submit"
                        onClick={handleNext}
                      >
                        {buttonLabel}
                      </SoftButton>
                      <SoftButton
                        style={{ float: "inline-end", marginRight: "10px" }}
                        variant="outlined"
                        color="dark"
                        size="small"
                        onClick={handleCloseModel}
                      >
                        Cancel
                      </SoftButton>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      )}
      {!pdfPreview && (
        <div className="card">
          <div className="card-header" style={{ position: "relative" }}>
            <h5>Document</h5>

            <div className="col-md-12">
              <SoftButton
                variant="outlined"
                style={{ float: "inline-end", marginTop: "-30px" }}
                color="dark"
                size="small"
                onClick={handlePerviewBack}
              >
                Back
              </SoftButton>
            </div>
          </div>
          <div className="card-body">
            <>
              <embed src={selectedPdf} type="application/pdf" width="100%" height="500px" />
            </>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
}

Documents.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  employeeDetail: PropTypes.func,
  isEditMode: PropTypes.bool,
};

Documents.defaultProps = {
  onNext: () => {},
  onBack: () => {},
  employeeDetail: () => {},
  isEditMode: false,
};

export default Documents;
